export default __webpack_public_path__ + "images/e3cfa0b03dd48c15ebb06356b883f353-world_music_small.webp";